"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const Typography_1 = require("../../atoms/Typography/Typography");
const ListItem_styles_1 = require("./ListItem.styles");
const accessibility_1 = require("../../../../shared/accessibility");
exports.ListItem = ({ title, onPress, RightComponent, LeftComponent, applyTopBorder = false, borderBottomWidth = 1, backgroundColor, color, accessibilityLabel, accessibilityHint, accessible = true, disabled = false, disabledLeftComponent, ...restProps }) => {
    const { id = `${title}-list-item` } = restProps;
    const theme = native_1.useTheme();
    const showLeftComponent = () => {
        if (disabled && disabledLeftComponent) {
            return (react_1.default.createElement(ListItem_styles_1.LeftComponentWrapper, null, disabledLeftComponent));
        }
        if (LeftComponent) {
            return react_1.default.createElement(ListItem_styles_1.LeftComponentWrapper, null, LeftComponent);
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    return (react_1.default.createElement(ListItem_styles_1.ListItemContainer, Object.assign({}, accessibility_1.accessibilityProps(id), { disabled: disabled, applyTopBorder: applyTopBorder, borderBottomWidth: borderBottomWidth, onPress: onPress, backgroundColor: backgroundColor || theme.bpCore.colors.white, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, accessibilityRole: "button", accessible: accessible }),
        react_1.default.createElement(ListItem_styles_1.LeftWrapper, null,
            showLeftComponent(),
            typeof title === 'string' ? (react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                react_1.default.createElement(Typography_1.PText, { type: Typography_1.PTextType.LEAD, color: disabled
                        ? theme.bpCore.colors.shadowLight
                        : color || theme.bpCore.colors.text }, title))) : (react_1.default.createElement(react_1.default.Fragment, null, title))),
        RightComponent && react_1.default.createElement(react_1.default.Fragment, null, RightComponent)));
};
